import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar, FaRegStar } from "react-icons/fa";
import Layout from "../../../Component/Layout"; // adjust path to match your project structure

const IndiaLocalization = () => {
  const navigate = useNavigate();

  const tiles = [
    {
      name: "HSN CODE",
      icon: <FaFileInvoiceDollar />,
      path: "/finance/localization/india/gst",
    },
    {
          name: "GST Report",
          icon: <FaFileInvoiceDollar />,
          path: "/finance/localization/gst",
        },
  ];

  return (
    <Layout>
      <style>{`
        .india-wrapper {
          padding: 32px;
          font-family: Inter, Poppins, sans-serif;
        }

        .india-header h1 {
          font-size: 26px;
          font-weight: 700;
          color: #0b1f4d;
          margin: 0 0 6px 0;
        }

        .india-header p {
          font-size: 14px;
          color: #6b7280;
          margin: 0 0 28px 0;
        }

        .india-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
        }

        .india-module-tile {
          width: 260px;
          background: #ffffff;
          border: 1px solid #edf0f5;
          border-radius: 16px;
          padding: 24px;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
          position: relative;
        }

        .india-module-tile:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(16, 24, 40, 0.10);
        }

        .india-module-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: #dbeafe;
          color: #2563eb;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          margin-bottom: 18px;
        }

        .india-module-star {
          position: absolute;
          top: 22px;
          right: 22px;
          color: #d1d5db;
          font-size: 15px;
        }

        .india-module-name {
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 6px;
        }

        .india-module-link {
          font-size: 13px;
          color: #6b7280;
        }
      `}</style>

      <div className="india-wrapper">
        <div className="india-header">
          <h1>India</h1>
          <p>India-specific finance and compliance configuration</p>
        </div>

        <div className="india-grid">
          {tiles.map((tile) => (
            <div
              key={tile.name}
              className="india-module-tile"
              onClick={() => navigate(tile.path)}
            >
              <FaRegStar className="india-module-star" />
              <div className="india-module-icon">{tile.icon}</div>
              <div className="india-module-name">{tile.name}</div>
              <div className="india-module-link">Open Module &rarr;</div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default IndiaLocalization;